import { ref } from "vue"
import { defineStore } from "pinia"
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem"
import { Capacitor } from "@capacitor/core"

export const useItemQueueStore = defineStore("item-queue", () => {
	const item_queue = ref([])

	async function add(item) {
		// If item already exists, remove it first
		item_queue.value = item_queue.value.filter((i) => i.id !== item.id)
		item_queue.value.push(item)
		await saveToLocal()
	}

	async function load() {
		// if (!Capacitor.isNativePlatform()) {
		// 	if (localStorage) {
		// 		try {
		// 			let _q = localStorage.getItem("gv_item_q") ?? "[]"
		// 			_q = JSON.parse(_q)
		// 			item_queue.value = _q
		// 		} catch (e) {
		// 			console.log(e)
		// 			item_queue.value = []
		// 		}
		// 	}
		// } else {
		try {
			const contents = await Filesystem.readFile({
				path: "gv_item_q.json",
				directory: Directory.Data,
				encoding: Encoding.UTF8,
			})
			item_queue.value = JSON.parse(contents?.data ?? "[]")
		} catch (e) {
			console.log(e)
			// alert(e.message)
			item_queue.value = []
		}
		// }
	}

	async function remove(id) {
		item_queue.value = item_queue.value.filter((item) => item.id !== id)
		await saveToLocal()
	}

	// (Optional) update item in place
	async function update(id, item) {
		const index = item_queue.value.findIndex((i) => i.id === id)
		if (index !== -1) {
			item_queue.value[index] = item
			await saveToLocal()
		}
	}

	async function saveToLocal() {
		// if (!Capacitor.isNativePlatform()) {
		// 	if (localStorage) {
		// 		localStorage.setItem("gv_item_q", JSON.stringify(item_queue.value))
		// 	}
		// } else {
		await Filesystem.writeFile({
			path: "gv_item_q.json",
			data: JSON.stringify(item_queue.value),
			directory: Directory.Data,
			encoding: Encoding.UTF8,
		})
		// console.log("SAVING", a)
		// }
	}

	return { item_queue, add, load, remove, update }
})
